import { reducer as templatesReducer } from '@sunwisesoftware/sunwise-template-core';
import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import alerts from 'common/modules/alerts';
import chat from 'common/modules/chat';
import commentArea from 'common/modules/commentArea';
import customColumns from 'common/modules/customColumns';
import fileUploader from 'common/modules/fileUploader';
import lisaFiles from 'common/modules/lisaFiles';
import privateDocuments from 'common/modules/privateDocuments';
import rejectForm from 'common/modules/rejectForm';
import zap from 'common/modules/zap';

import afterSalesConsumptionHistory from '../afterSalesConsumptionHistory';
import afterSalesMeasurementSource from '../afterSalesMeasurementSource';
import afterSalesMonitoring from '../afterSalesMonitoring';
import afterSalesSettings from '../afterSalesSettings';
import companyGeneral from '../companyGeneral';
import companyRoles from '../companyRoles';
import companyUsers from '../companyUsers';
import configurationDocuments from '../configurationDocuments';
import configurationInsurances from '../configurationInsurances';
import credentialIntegrations from '../credentialIntegrations';
import creditFile from '../creditFile';
import credits from '../credits';
import dashboard from '../dashboard';
import editTemplateView from '../editTemplateView';
import financial from '../financial';
import financialFormsCore from '../financialFormsCore';
import funnelFinancing from '../funnelFinancing';
import installerProfile from '../installerProfile';
import installers from '../installers';
import login from '../login';
import multiCurrency from '../multiCurrency';
import notifications from '../notifications';
import powerStations from '../powerStations';
import profile from '../profile';
import profileConfiguration from '../profileConfiguration';
import profileSecurity from '../profileSecurity';
import proposalPreview from '../proposalPreview';
import quotes from '../quotes';
import reportList from '../reportList';
import reportPreview from '../reportPreview';
import reportReviewPro from '../reportReviewPro';
import reportTemplateReview from '../reportTemplateReview';
import resetPasswordUser from '../resetPasswordUser';
import supplierIntegrations from '../supplierIntegrations';
import templateDocuments from '../templateDocuments';
import templates from '../templates';

export default (history) =>
    combineReducers({
        [afterSalesConsumptionHistory.NAME]:
            afterSalesConsumptionHistory.reducer,
        [afterSalesMeasurementSource.NAME]: afterSalesMeasurementSource.reducer,
        [afterSalesMonitoring.NAME]: afterSalesMonitoring.reducer,
        [afterSalesSettings.NAME]: afterSalesSettings.reducer,
        [alerts.NAME]: alerts.reducer,
        [chat.NAME]: chat.reducer,
        [commentArea.NAME]: commentArea.reducer,
        [companyGeneral.NAME]: companyGeneral.reducer,
        [companyRoles.NAME]: companyRoles.reducer,
        [companyUsers.NAME]: companyUsers.reducer,
        [configurationDocuments.NAME]: configurationDocuments.reducer,
        [configurationInsurances.NAME]: configurationInsurances.reducer,
        [credentialIntegrations.NAME]: credentialIntegrations.reducer,
        [creditFile.NAME]: creditFile.reducer,
        [credits.NAME]: credits.reducer,
        [customColumns.NAME]: customColumns.reducer,
        [dashboard.NAME]: dashboard.reducer,
        [editTemplateView.NAME]: editTemplateView.reducer,
        [fileUploader.NAME]: fileUploader.reducer,
        [financial.NAME]: financial.reducer,
        [financialFormsCore.NAME]: financialFormsCore.reducer,
        [funnelFinancing.NAME]: funnelFinancing.reducer,
        [installerProfile.NAME]: installerProfile.reducer,
        [installers.NAME]: installers.reducer,
        [lisaFiles.NAME]: lisaFiles.reducer,
        [login.NAME]: login.reducer,
        [multiCurrency.NAME]: multiCurrency.reducer,
        [notifications.NAME]: notifications.reducer,
        [powerStations.NAME]: powerStations.reducer,
        [privateDocuments.NAME]: privateDocuments.reducer,
        [profile.NAME]: profile.reducer,
        [profileConfiguration.NAME]: profileConfiguration.reducer,
        [profileSecurity.NAME]: profileSecurity.reducer,
        [proposalPreview.NAME]: proposalPreview.reducer,
        [quotes.NAME]: quotes.reducer,
        [rejectForm.NAME]: rejectForm.reducer,
        [reportList.NAME]: reportList.reducer,
        [reportPreview.NAME]: reportPreview.reducer,
        [reportReviewPro.NAME]: reportReviewPro.reducer,
        [reportTemplateReview.NAME]: reportTemplateReview.reducer,
        [resetPasswordUser.NAME]: resetPasswordUser.reducer,
        [supplierIntegrations.NAME]: supplierIntegrations.reducer,
        [templateDocuments.NAME]: templateDocuments.reducer,
        [templates.NAME]: templates.reducer,
        [zap.NAME]: zap.reducer,
        router: connectRouter(history),
        sunwiseTemplateCore: templatesReducer,
    });
